import React from "react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactElement;
  label: string;
  size: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-6 px-2 [&_svg]:size-4",
  md: "w-8 px-2 [&_svg]:size-6",
  lg: "w-10 px-2 [&_svg]:size-8",
};

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, label, size, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant='ghost'
        size='icon'
        name={label}
        className={cn(
          sizeClasses[size],
          "focus-visible:ring-0 focus-visible:ring-offset-0",
        )}
        aria-label={label}
        {...props}
      >
        {React.cloneElement(icon, { "aria-hidden": "true" })}
      </Button>
    );
  },
);

IconButton.displayName = "IconButton";

export default IconButton;
